module.exports = __webpack_public_path__ + "img/error.fdc0313e.png";